// extracted by mini-css-extract-plugin
export default {"hilfeLink":"HilfeLink_hilfeLink__i01dh"};